import React from 'react';
import { UploadZone, AnswerUploadZone } from './components/UploadZone';
import { SourcePreview } from './components/SourcePreview';
import { ExtractionEditor } from './components/ExtractionEditor';
import { useQBStore } from '@/store/qbStore';
import { Button } from '@/components/ui/button';
import { Loader2, Save } from 'lucide-react';
import { MetadataEditor } from './components/MetadataEditor';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ExtractionPage: React.FC = () => {
  const { 
    isExtracting, 
    uploadAndExtract, 
    files, 
    draftQuestions,
    saveAll,
    isSaving,
    extractionMethod,
    setExtractionMethod
  } = useQBStore();

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b px-6 py-3 flex items-center justify-between">
        <h1 className="text-xl font-bold text-gray-800">智能录题 (Smart Extraction)</h1>
        <div className="flex gap-2 items-center">
          <Select 
            value={extractionMethod} 
            onValueChange={(value: 'standard' | 'markdown') => setExtractionMethod(value)}
            disabled={isExtracting || draftQuestions.length > 0}
          >
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="选择提取模式" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="standard">标准模式 (Standard)</SelectItem>
              <SelectItem value="markdown">Markdown模式 (实验性)</SelectItem>
            </SelectContent>
          </Select>
          
          <Button 
            onClick={uploadAndExtract} 
            disabled={files.length === 0 || isExtracting}
            variant="secondary"
          >
            {isExtracting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                识别中...
              </>
            ) : (
              '开始识别'
            )}
          </Button>
          <Button 
            onClick={saveAll} 
            disabled={draftQuestions.length === 0 || isSaving}
          >
            {isSaving ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                保存中...
              </>
            ) : (
              <>
                <Save className="mr-2 h-4 w-4" />
                批量入库 ({draftQuestions.length})
              </>
            )}
          </Button>
        </div>
      </header>

      {/* Main Content */}
      <div className="flex-1 overflow-hidden p-4 flex gap-4">
        {/* Left Column: Upload & Preview */}
        <div className="w-1/3 flex flex-col gap-4">
          <UploadZone />
          {extractionMethod === 'markdown' && <AnswerUploadZone />}
          <div className="flex-1 overflow-hidden">
            <SourcePreview />
          </div>
        </div>

        {/* Right Column: Editor */}
        <div className="w-2/3 flex flex-col gap-4 overflow-hidden">
           {draftQuestions.length > 0 && (
             <MetadataEditor />
           )}
           <div className="flex-1 flex flex-col bg-white rounded-lg shadow border overflow-hidden">
             <div className="p-3 border-b bg-gray-50 font-medium text-sm text-gray-600">
               识别结果
             </div>
             <div className="flex-1 overflow-y-auto p-4">
               <ExtractionEditor />
             </div>
           </div>
        </div>
      </div>
    </div>
  );
};

export default ExtractionPage;
